import { IonText, IonButton } from '@ionic/react';
import './PointsEarned.scss';

import Trophy from 'components/Trophy/Trophy';
import { useEffect } from 'react';

interface PointsEarnedProps {
  title: string;
  onComplete: Function;
}

const PointsEarned: React.FC<PointsEarnedProps> = ({ title, onComplete }) => {
  useEffect(() => {
    onComplete(true);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="PointsEarned">
      <Trophy />

      <div className="pb-5" />

      <IonText color="white">
        <h1 className="ion-text-center px-5">
          Thank you for participating in Elanco's Learn & Earn game with us!
        </h1>
      </IonText>

      <div className="pb-4" />

      <IonText color="white">
        <h2 className="ion-text-center text-h2 px-8">
          You've completed {title}.
        </h2>
      </IonText>

      <div className="pb-6" />
      <div className="ion-text-center">
        <IonButton routerLink="/dashboard" strong>
          Back to home
        </IonButton>
      </div>
    </div>
  );
};

export default PointsEarned;
